// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ContactUsAttachmentController from "./contact_us_attachment_controller"
application.register("contact-us-attachment", ContactUsAttachmentController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

// import InitializeDataTableController from "./initialize_data_table_controller"
// application.register("initialize-data-table", InitializeDataTableController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import CustomFileController from "./custom_file_controller.js"
application.register("custom-file", CustomFileController)

// import DeleteDialogController from "./delete_dialog_controller.js"
// application.register("delete-dialog", DeleteDialogController)

import TrixValidationController from "./trix_validation_controller.js"
application.register("trix-validation", TrixValidationController)

import ModalFocusController from "./modal_focus_controller"
application.register("modal-focus", ModalFocusController)

import TinymceController from "./tinymce_controller"
application.register("tinymce", TinymceController)

import ContentTypeController from "./content_type_controller"
application.register("content-type", ContentTypeController)

import AnnouncementController from "./announcement_controller"
application.register("announcement", AnnouncementController)

import SpeechNotificationController from "./speech_notification_controller"
application.register("speech-notification", SpeechNotificationController)

import PerPageController from "./per_page_controller"
application.register("per-page", PerPageController)